var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("h4", [
          _vm._v(_vm._s(_vm.lead.ref_id) + " - Send a follow up Email")
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _c("div", { staticClass: "row mb-1" }, [
          _c(
            "div",
            { staticClass: "col pl-3 pr-1" },
            [
              _c(
                "div",
                { staticClass: "select-wrap" },
                [
                  _c("label", [_vm._v("Email")]),
                  _vm._v(" "),
                  _vm.customerContactsWithEmail
                    ? _c("simple-select", {
                        attrs: {
                          options: _vm.customerContactsWithEmail,
                          label: "email",
                          "return-value": "email",
                          placeholder: "Select recipient"
                        },
                        model: {
                          value: _vm.customer_email_selected,
                          callback: function($$v) {
                            _vm.customer_email_selected = $$v
                          },
                          expression: "customer_email_selected"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("error-field", { attrs: { errors: _vm.errors, field: "to" } })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col pl-1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-2" }, [
          _c(
            "div",
            { staticClass: "col-6 pr-1" },
            [
              _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("Subject")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.followUp.subject,
                      expression: "followUp.subject"
                    }
                  ],
                  ref: "subject",
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.followUp.subject },
                  on: {
                    click: function($event) {
                      _vm.addingVariableOn = "subject"
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.followUp, "subject", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "subject" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 pl-1" }, [
            _c(
              "div",
              { staticClass: "select-wrap" },
              [
                _c("label", [_vm._v("Choose from template")]),
                _vm._v(" "),
                _c("simple-select", {
                  attrs: {
                    options: _vm.followUp.emailTemplates,
                    placeholder: "Select template"
                  },
                  on: { input: _vm.loadEmailTemplate },
                  model: {
                    value: _vm.followUp.template,
                    callback: function($$v) {
                      _vm.$set(_vm.followUp, "template", $$v)
                    },
                    expression: "followUp.template"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-2" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("div", { staticClass: "select-wrap h-auto" }, [
                _c("label", [_vm._v("Email body")]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.followUp.body,
                      expression: "followUp.body"
                    }
                  ],
                  ref: "ta",
                  staticClass: "select-wrap-textarea form-control",
                  attrs: { name: "", id: "", cols: "30", rows: "10" },
                  domProps: { value: _vm.followUp.body },
                  on: {
                    click: function($event) {
                      _vm.addingVariableOn = "ta"
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.followUp, "body", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "body" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              _vm._l(_vm.followUp.variables, function(variable, key, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    staticClass:
                      "badge badge-primary mx-1 unselectable pointer",
                    on: {
                      dblclick: function($event) {
                        _vm.insertVariable(variable)
                      }
                    }
                  },
                  [_vm._v(_vm._s(key))]
                )
              })
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-4" }, [
          _c("div", { staticClass: "col text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary w-100 ld-ext-right",
                class: _vm.loadingButton ? "running" : "",
                attrs: { type: "button", disabled: _vm.buttonDisabled },
                on: {
                  click: function($event) {
                    _vm.emailFollowup(_vm.lead.id)
                  }
                }
              },
              [
                _vm._v("\n          Send Email\n          "),
                _c("div", { staticClass: "ld ld-ball ld-flip" })
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b8c0fdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8c0fdc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/followUps/Email.vue
// module id = null
// module chunks = 